type CallbackFn = () => void;

const callbackRegistry: Record<string, CallbackFn> = {};

export const registerNotifierCallback = (key: string, callback: CallbackFn) => {
  callbackRegistry[key] = callback;
};

export const getNotifierCallback = (key: string): CallbackFn | undefined => {
  return callbackRegistry[key];
};

export const unregisterNotifierCallback = (key: string) => {
  delete callbackRegistry[key];
};
